import ExecutaRest from '../util/ExecutaRest'

class TipoPessoaApi {

    static ListarTipoPessoa(data) {

        var rest = new ExecutaRest();
        return new Promise(function (resolve, reject) {

            rest.Post('TipoPessoaSL.svc/rest/ListarTipoPessoaVisivelREST', data).then(retorno => {
                if (retorno.dado) {
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro) {
                    reject(retorno.erro);
                }
            }).catch(error => {
                reject('Ocorreu um erro inesperado em --> ListarTipoPessoaVisivelREST: ' + error /*areaTratamento.statusText*/);
            });

        });

    }

}

export default TipoPessoaApi;


/** WEBPACK FOOTER **
 ** ./src/components/api/tipoPessoaApi.js
 **/